<td>{{curve.location}}</td>
<td>{{curve.dimensionA}}</td>
<td>{{curve.dimensionB}}</td>
<td>{{curve.system}}</td>
<td>{{curve.railColour}}</td>
